var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['inner-area',{
	'jdy-solid-box':_vm.borderStyle=='solid'||!_vm.borderStyle,
	'jdy-dotted-box':_vm.borderStyle=='dotted',
	'jdy-dashed-box':_vm.borderStyle=='dashed'
}],style:({'background':_vm.areaColor})},[(_vm.showTitle)?_c('header',{staticClass:"jdy-inner-title",style:({"background":_vm.titleColor })},[_vm._t("area-title")],2):_vm._e(),_vm._v(" "),_c('el-scrollbar',{style:({"height": _vm.contentHeight ? _vm.contentHeight : _vm.showTitle ? "calc(100% - 41px)" : "100%" })},[_c('section',{staticClass:"jdy-inner-body",style:({'padding':_vm.nopadding})},[_vm._t("area-body")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca4e7354","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inner-area.vue
// module id = null
// module chunks = 